import AvatarUploadDialog from './AvatarUploadDialog';
import './style/index.less';

export default AvatarUploadDialog;
